import React from 'react'

export default function ArrowDownIcon() {
  return (
    <svg
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.82053 4.3L0.919929 1.7C0.566651 1.38333 0.487814 1.021 0.683418 0.613C0.878279 0.204333 1.22672 0 1.72875 0H7.47417C7.97619 0 8.32464 0.204333 8.5195 0.613C8.7151 1.021 8.63626 1.38333 8.28299 1.7L5.38239 4.3C5.27083 4.4 5.14997 4.475 5.01981 4.525C4.88966 4.575 4.75021 4.6 4.60146 4.6C4.45271 4.6 4.31326 4.575 4.1831 4.525C4.05295 4.475 3.93209 4.4 3.82053 4.3Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}
